@let user = user$();
@if (user?.email) {
  <div class="navbar-profile azavista-horizontal-stack" [matMenuTriggerFor]="menu">
    <div class="navbar-profile__name">
      <ng-container [ngTemplateOutlet]="elementName"></ng-container>
    </div>
    <div class="navbar-profile__image">
      <ng-container [ngTemplateOutlet]="elementProfileImage"></ng-container>
    </div>
  </div>
}

<mat-menu #menu="matMenu">
  <div
    class="navbar-profile navbar-profile__popup azavista-vertical-stack centered-content"
    >
    <div class="navbar-profile__image">
      <ng-container
        [ngTemplateOutlet]="elementProfileImage"
      ></ng-container>
    </div>
    <div class="navbar-profile__name">
      <ng-container [ngTemplateOutlet]="elementName"></ng-container>
    </div>
    <div class="navbar-profile__email">
      <p>{{user?.email}}</p>
    </div>
    <div class="navbar-profile__action">
      <azavista-button (click)="logout()">
        <mat-icon>exit_to_app</mat-icon>
        {{ translations.LOGOUT | translate }}
      </azavista-button>
    </div>
  </div>
</mat-menu>

<ng-template #elementName>
  {{ user?.first_name }} {{ user?.last_name }}
</ng-template>

<ng-template #elementProfileImage>
  <mat-icon>person</mat-icon>
</ng-template>
